module.exports = require("@seddi/three/addons/loaders/GLTFLoader.js");